import { useContext } from "react";
import { AppContext } from "../../contexts/app";
import { ACTIONS } from "../../contexts/app/actions";

const useSelectObject = () => {
  const { state, dispatch } = useContext(AppContext);

  const selectedObject = state.selectedObject;

  const setSelectedObject = (object) => {
    dispatch({
      type: ACTIONS.SELECT_OBJECT,
      value: object,
    });
  };

  return { selectedObject, setSelectedObject };
};

export default useSelectObject;
